module.exports = __webpack_public_path__ + "media/images/download/e-book08-344f75197732d4493851517cf0fe38c0.png";